<template>
  <section>
    <v-container class="till-layout">
      <v-layout justify-end>
        <v-flex shrink>
          <v-switch
            v-model="showInfo"
            color="info"
            append-icon="help_outline"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-stepper non-linear>
        <v-stepper-step
          editable
          step="1"
          :complete="validation.userNameValid"
          :edit-icon="$vuetify.icons.complete"
        >
          Informations de bases
          <small v-show="userName !== ''">Nom: {{ userName }}</small>
          <small v-show="comment !== ''">Commentaire: {{ comment }}</small>
        </v-stepper-step>
        <v-stepper-content step="1">
          <TillBaseInfo
            :userName.sync="userName"
            :comment.sync="comment"
            :valid.sync="validation.userNameValid"
          ></TillBaseInfo>
        </v-stepper-content>
        <v-stepper-step
          :editable="validation.userNameValid"
          step="2"
          :complete="validation.dateRangeValid"
          :edit-icon="$vuetify.icons.complete"
        >
          Sélection de la/les date(s)
          <small v-show="dates.length > 0"
            >Date(s): {{ dates.reduce((a, b) => a + " " + b, "") }}</small
          >
          <small v-show="sales > 0">Ventes: {{ sales }}$</small>
        </v-stepper-step>
        <v-stepper-content step="2">
          <TillDateRange
            :dates.sync="dates"
            :sales.sync="sales"
            :valid.sync="validation.dateRangeValid"
            :show-info="showInfo"
          ></TillDateRange>
        </v-stepper-content>
        <v-stepper-step
          :editable="validation.dateRangeValid"
          step="3"
          :complete="validation.paymentsValid"
          :edit-icon="$vuetify.icons.complete"
        >
          Méthodes de paiements des clients
          <small v-show="payments.cash > 0"
            >Comptant: {{ payments.cash }}</small
          >
          <small v-show="payments.debit > 0"
            >Debit: {{ payments.debit }}$</small
          >
          <small v-show="payments.visa > 0">Visa: {{ payments.visa }}$</small>
          <small v-show="payments.master > 0"
            >Master: {{ payments.master }}$</small
          >
          <small v-show="payments.certificat > 0"
            >Certificats: {{ payments.certificat }}$</small
          >
          <small v-show="payments.client > 0"
            >Comptes client: {{ payments.client }}$</small
          >
          <small v-show="payments.others > 0"
            >Autres: {{ payments.others }}$</small
          >
        </v-stepper-step>
        <v-stepper-content step="3">
          <TillPayments
            :cash="payments.cash"
            :debit.sync="payments.debit"
            :visa.sync="payments.visa"
            :master.sync="payments.master"
            :certificat.sync="payments.certificat"
            :client.sync="payments.client"
            :others.sync="payments.others"
            :valid.sync="validation.paymentsValid"
            :show-info="showInfo"
          ></TillPayments>
        </v-stepper-content>
        <v-stepper-step
          :editable="validation.dateRangeValid"
          step="4"
          :complete="validation.tipsValid"
          :edit-icon="$vuetify.icons.complete"
        >
          Pourboires
          <small v-show="tips.cash > 0">Comptant: {{ tips.cash }}$</small>
          <small v-show="tips.tpv > 0">Tpv: {{ tips.tpv }}$</small>
          <small v-show="tips.others > 0">Autres: {{ tips.others }}$</small>
          <small v-show="tips.total > 0">Total: {{ tips.total }}$</small>
        </v-stepper-step>
        <v-stepper-content step="4">
          <TillTips
            :cash.sync="tips.cash"
            :tpv.sync="tips.tpv"
            :others.sync="tips.others"
            :total.sync="tips.total"
            :valid.sync="validation.tipsValid"
          ></TillTips>
        </v-stepper-content>
        <v-stepper-step
          :editable="validation.dateRangeValid"
          step="5"
          :complete="validation.directPurchaseValid"
          :edit-icon="$vuetify.icons.complete"
        >
          Déboursés
          <small v-show="directPurchases.length > 0"
            >Nombre: {{ directPurchases.length }}</small
          >
          <small v-show="directPurchasesTotal > 0"
            >Total: {{ directPurchasesTotal }}$</small
          >
        </v-stepper-step>
        <v-stepper-content step="5">
          <TillDirectPurchase
            :direct-purchases.sync="directPurchases"
            :total.sync="directPurchasesTotal"
            :valid.sync="validation.directPurchaseValid"
            :show-info="showInfo"
          ></TillDirectPurchase>
        </v-stepper-content>
        <v-stepper-step
          :editable="validation.dateRangeValid"
          step="6"
          :complete="validation.caisseValid"
          :edit-icon="$vuetify.icons.complete"
        >
          Caisse
          <small v-show="caisse.total > 0">Total: {{ caisse.total }}$</small>
        </v-stepper-step>
        <v-stepper-content step="6">
          <TillCaisse
            v-bind.sync="caisse"
            :valid.sync="validation.caisseValid"
            :show-info="showInfo"
          ></TillCaisse>
        </v-stepper-content>
        <v-stepper-step
          :editable="validation.caisseValid"
          step="7"
          :complete="validation.reportValid"
          :edit-icon="$vuetify.icons.complete"
        >
          Vérification
          <small v-show="caisse.total > 0">
            Écart de la caisse:
            <span v-show="ecart > 0">+</span>
            {{ ecart }}$
          </small>
        </v-stepper-step>
        <v-stepper-content step="7">
          <TillReport
            :ecart.sync="ecart"
            :dates="dates"
            :caisse="caisse.total"
            :payment="payments.cash"
            :direct-purchases="directPurchasesTotal"
            :valid.sync="validation.reportValid"
            :show-info="showInfo"
          ></TillReport>
        </v-stepper-content>
        <v-stepper-step
          :editable="validation.caisseValid"
          step="8"
          :edit-icon="$vuetify.icons.complete"
        >
          Préparer le fond de caisse & Dépôt
        </v-stepper-step>
        <v-stepper-content step="8">
          <TillAfter
            ref="tillAfter"
            :currentCaisse="caisse"
            :till-id="this.tillId"
            :fondCaisse.sync="fondCaisse"
            :depositValue.sync="depositValue"
            @save="saveTill"
          ></TillAfter>
        </v-stepper-content>
      </v-stepper>
    </v-container>
  </section>
</template>

<script>
import round10 from "round10";
import { api } from "@/api";
import moment from "moment";
import TillBaseInfo from "../components/TillBaseInfo";
import TillDateRange from "../components/TillDateRange";
import TillPayments from "../components/TillPayments";
import TillTips from "../components/TillTips";
import TillDirectPurchase from "../components/TillDirectPurchaseSection";
import TillCaisse from "../components/TillCaisse";
import TillReport from "../components/TillReport";
import TillAfter from "../components/TillAfter";
import { userInfosMixin } from "@/mixins/userInfosMixin";
export default {
  mixins: [userInfosMixin],
  name: "TillCreator",
  components: {
    TillBaseInfo,
    TillDateRange,
    TillPayments,
    TillTips,
    TillDirectPurchase,
    TillCaisse,
    TillReport,
    TillAfter
  },
  async created() {
    this.$store.dispatch("loadSales");
    this.$store.dispatch("loadTills", this.storeId);
  },
  data() {
    return {
      tillSaved: false,
      tillDate: null,
      tillId: null,
      loading: false,
      showInfo: false,
      showTillAfter: false,
      validation: {
        dateRangeValid: false,
        userNameValid: false,
        paymentsValid: false,
        tipsValid: false,
        directPurchaseValid: false,
        caisseValid: false,
        reportValid: false
      },
      saved: {
        till: false,
        payments: false,
        tips: false,
        caisse: false,
        directPurchases: false,
        deposit: false,
        fondCaisse: false
      },
      userName: "",
      comment: "",
      sales: 0,
      dates: [],
      payments: {
        cash: 0,
        debit: 0,
        master: 0,
        visa: 0,
        certificat: 0,
        client: 0,
        others: 0
      },
      tips: {
        cash: 0,
        tpv: 0,
        others: 0,
        total: 0
      },
      directPurchases: [],
      directPurchasesTotal: 0,
      caisse: {
        argent_5cent: 0,
        argent_10cent: 0,
        argent_25cent: 0,
        argent_1dollar: 0,
        argent_2dollar: 0,
        argent_5dollar: 0,
        argent_10dollar: 0,
        argent_20dollar: 0,
        argent_50dollar: 0,
        argent_100dollar: 0,
        rouleaux_5cent: 0,
        rouleaux_10cent: 0,
        rouleaux_25cent: 0,
        rouleaux_1dollar: 0,
        rouleaux_2dollar: 0,
        total: 0
      },
      fondCaisse: {},
      depositValue: 0,
      ecart: 0
    };
  },
  computed: {
    totalPaymentsWithoutCash() {
      return round10.round10(
        this.payments.debit +
          this.payments.master +
          this.payments.visa +
          this.payments.certificat +
          this.payments.client +
          this.payments.others,
        -2
      );
    }
  },
  methods: {
    getCashValue() {
      this.payments.cash = round10.round10(
        this.sales - this.totalPaymentsWithoutCash,
        -2
      );
    },
    mapCaisseToBackEnd() {
      const caisse = {
        is_default: false,
        store: this.storeId,
        ...this.caisse
      };
      return caisse;
    },
    async saveTill() {
      try {
        this.$store.dispatch("slo");
        this.loading = true;
        if (this.tillId === null) {
          await this.createTill();
        }
        if (this.saved.till === true) {
          await Promise.all([
            this.createCaisse(),
            this.createDirectPurchase(),
            this.createPayments(),
            this.createTips(),
            this.createDeposit(),
            this.createFondCaisse()
          ]);
          this.$router.push({ name: "TillIndex" });
        }
      } finally {
        this.$store.dispatch("elo");
        this.loading = false;
      }
    },
    async createTill() {
      const sortedDates = this.dates
        .map(d => moment(d))
        .sort((a, b) => a.diff(b));
      const data = {
        store: this.storeId,
        start_date: sortedDates[0].format("YYYY-MM-DD"),
        end_date:
          sortedDates.length > 0
            ? sortedDates[sortedDates.length - 1].format("YYYY-MM-DD")
            : sortedDates[0].format("YYYY-MM-DD"),
        signataire: this.userName,
        commentaire: this.comment,
        ecart_caisse: this.ecart
      };
      try {
        const res = await api.postTill(data);
        this.saved.till = true;
        this.tillId = res.id;
        this.tillDate = res.end_date;
      } catch (error) {
        this.saved.till = false;
        return Promise.reject(error);
      }
    },
    async createCaisse() {
      if (this.saved.caisse !== true) {
        const data = {
          ...this.caisse,
          id_till: this.tillId,
          store: this.storeId
        };
        try {
          await api.postCaisse(data);
          this.saved.caisse = true;
        } catch (error) {
          this.saved.caisse = false;
          return Promise.reject(error);
        }
      }
    },
    async createTips() {
      if (this.saved.tips !== true) {
        const data = {
          ...this.tips,
          id_till: this.tillId,
          store: this.storeId
        };
        try {
          await api.postTips(data);
          this.saved.tips = true;
        } catch (error) {
          this.saved.tips = false;
          return Promise.reject(error);
        }
      }
    },
    async createPayments() {
      if (this.saved.payments !== true) {
        const data = {
          ...this.payments,
          id_till: this.tillId,
          store: this.storeId
        };
        try {
          await api.postPayments(data);
          this.saved.payments = true;
        } catch (error) {
          this.saved.payments = false;
          return Promise.reject(error);
        }
      }
    },
    async createDirectPurchase() {
      if (this.saved.directPurchases !== true) {
        const tasks = [];
        this.directPurchases.map(d => {
          const data = {
            id_till: this.tillId,
            store: this.storeId,
            date: this.tillDate,
            ...d
          };
          tasks.push(api.postDirectPurchase(data));
        });
        try {
          await Promise.all(tasks);
          this.saved.directPurchases = true;
        } catch (error) {
          this.saved.directPurchases = false;
          return Promise.reject(error);
        }
      }
    },
    async createDeposit() {
      if (this.saved.deposit !== true) {
        const data = {
          id_till: this.tillId,
          store: this.storeId,
          value: round10.round10(
            Number(this.$refs.tillAfter.getDepositValue()),
            -2
          )
        };
        try {
          await api.postDeposit(data);
          this.saved.deposit = true;
        } catch (error) {
          this.saved.deposit = false;
          return Promise.reject(error);
        }
      }
    },
    async createFondCaisse() {
      if (this.saved.fondCaisse !== true) {
        const data = {
          ...this.$refs.tillAfter.getNewFondCaisse(),
          id_till: this.tillId,
          store: this.storeId,
          is_default: false
        };
        try {
          await api.postFondCaisse(data);
          this.saved.fondCaisse = true;
        } catch (error) {
          this.saved.fondCaisse = false;
          return Promise.reject(error);
        }
      }
    }
  },
  watch: {
    payments: {
      deep: true,
      handler: "getCashValue"
    },
    sales: {
      handler: "getCashValue"
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/style/colors.scss";
@media only screen and (max-width: 959px) {
  .v-stepper__label {
    margin-left: 1rem;
    display: flex !important;
  }
}
</style>
